const apiBaseURL = process.env.API_BASE_URL;

export const URL = {
    LOGIN_IN_URL: `${apiBaseURL}/api/admin/login`,
    LOG_OUT_URL: `${apiBaseURL}/api/admin/logout`,
    VERIFY_TOKEN_URL: `${apiBaseURL}/api/admin/verify-token`,
    ADD_PRODUCT_URL: `${apiBaseURL}/api/admin/product/add-product`,
    PRODUCT_LIST_URL: `${apiBaseURL}/api/admin/product/product-list`,
    UPDATE_PRODUCT_URL: `${apiBaseURL}/api/admin/product/edit-product`,
    DELETE_PRODUCT_URL: `${apiBaseURL}/api/admin/product/delete-product`,
    ADD_MEMBER_URL: `${apiBaseURL}/api/admin/member/add-member`,
    MEMBER_LIST_URL: `${apiBaseURL}/api/admin/member/member-list`,
    MEMBER_LIST_FOR_ASSIGN_URL: `${apiBaseURL}/api/admin/member/member-list-for-assign`,
    ADD_DEALER_URL: `${apiBaseURL}/api/admin/add-dealer`,
    DEALER_LIST_URL: `${apiBaseURL}/api/admin/dealer-list`,
    EDIT_DEALER_URL: `${apiBaseURL}/api/admin/edit-dealer`,
    DELETE_DEALER_URL: `${apiBaseURL}/api/admin/delete-dealer`,
    UPDATE_DEALER_ORDER_URL: `${apiBaseURL}/api/admin/update-dealer-order`,
    DEALER_LIST_WITH_ASSIGNEE_URL: `${apiBaseURL}/api/admin/dealer-list-with-assignee`,
    UNASSIGNED_DEALER_LIST_URL: `${apiBaseURL}/api/admin/member/unassigned-shops`,
    ASSIGN_SHOP_OPERATION_URL: `${apiBaseURL}/api/admin/member/assign-shop-operation`,
    BULK_ASSIGN_SHOP_URL: `${apiBaseURL}/api/admin/member/bulk-assign-shops`,
    UPLOAD_IMAGE: `${apiBaseURL}/api/admin/upload-image`,
    AGENCIES_URL: `${apiBaseURL}/api/admin/agencies`,
    ADD_AGENCY_URL: `${apiBaseURL}/api/admin/agency/add-agency`,
    AGENCY_LIST_URL: `${apiBaseURL}/api/admin/agency/agency-list`,
    UPDATE_AGENCY_URL: `${apiBaseURL}/api/admin/agency/edit-agency`,
    DELETE_AGENCY_URL: `${apiBaseURL}/api/admin/agency/delete-agency`,
    ORDER_DATA_EXCEL_URL: `${apiBaseURL}/api/admin/order/get-order-data-excel`,
    CLOSE_TAKING_ORDER: `${apiBaseURL}/api/admin/order/close-taking-order`,
    DEALER_LIST_WITH_PENDING_ORDER: `${apiBaseURL}/api/admin/pending-order-dealer-list`,
    ROUTE_SHEET_URL: `${apiBaseURL}/api/admin/order/get-order-route-excel`,
    TRACK_SHEET_URL: `${apiBaseURL}/api/admin/order/get-order-truck-excel`,
    UPLOAD_ORDER_EXCEL_URL: `${apiBaseURL}/api/admin/order/update-orders-from-excel`,
    ORDER_DATA_URL: `${apiBaseURL}/api/admin/order/get-order-data-display`,
    INVOICE_PURCHASE_URL: `${apiBaseURL}/api/admin/invoice/get-purchase-invoice-display`,
    UPLOAD_PURCHASE_INVOICE_URL: `${apiBaseURL}/api/admin/invoice/upload-purchase-invoice`,
    VERIFY_CRATE_COUNT_URL: `${apiBaseURL}/api/admin/invoice/verify-crate-count`,
    VERIFICATION_DATA_URL: `${apiBaseURL}/api/admin/invoice/purchase-sales-comparison`,
    ADD_SPEND_URL: `${apiBaseURL}/api/admin/spend/add`,
    SPEND_LIST_URL: `${apiBaseURL}/api/admin/spend/list`,
    FINANCIAL_METRICS_URL: `${apiBaseURL}/api/admin/financial-metrics`,
    AGENCY_INVOICE_SETTINGS_URL: `${apiBaseURL}/api/admin/invoice/agency`,
    GENERATE_INVOICE_URL: `${apiBaseURL}/api/admin/invoice/generate-sale-invoices`,
    INVOICE_SALE_URL: `${apiBaseURL}/api/admin/invoice/get-sale-invoice-display`,
    COLLECTION_BY_DATE_URL: `${apiBaseURL}/api/admin/collection/by-date`,
    MEMBER_TRANSACTIONS_URL: `${apiBaseURL}/api/admin/collection/member-transactions`,
    TODAY_COLLECTION_URL: `${apiBaseURL}/api/admin/collection/today-collection`,
    DEALER_TRANSACTIONS_URL: `${apiBaseURL}/api/admin/collection/transactions`,
    UPDATE_PURCHASE_INVOICE_URL: `${apiBaseURL}/api/admin/invoice/update-purchase-invoice`,
    UPDATE_MEMBER_URL: `${apiBaseURL}/api/admin/member/edit-member`,
    DELETE_MEMBER_URL: `${apiBaseURL}/api/admin/member/delete-member`,
    DELETE_PURCHASE_INVOICE_URL: `${apiBaseURL}/api/admin/invoice/delete-purchase-invoice`,
    MANUAL_PURCHASE_INVOICE_URL: `${apiBaseURL}/api/admin/invoice/manual-purchase-invoice`
};